export default __webpack_public_path__ + "static/media/bg7.e1687fce.jpg";